/**
 * SHERIK HUQUQ KODLARI — ADR-029 §3.
 *
 * ⚠️ BU KATALOG EMAS, NOMLAR RO'YXATI. Admin panelidagi `PERMISSIONS`
 * massivi kelgan kodlarni FILTRLAYDI va noma'lumini jimgina tashlaydi
 * — o'sha nuqson u yerda besh marta takrorlangan. Bu yerda hech narsa
 * filtrlanmaydi (`authApi.ts` dagi izoh); fayl faqat "satr bir joyda
 * yozilsin" degan maqsadga xizmat qiladi.
 *
 * ⚠️ HAQIQAT MANBAI — `xsib-identity` →
 * `partner/domain/PartnerKind.java`. To'plam KODDA qotirilgan
 * (ADR-029 §2), ya'ni bu yerdagi tekshiruvlar rol tahriridan emas,
 * faqat sherik TURIDAN kelib chiqadi:
 *
 *   AGENT    — `subscriber.directory`, `agent.fund`, `grant.issue`,
 *              `agent.read`, `payment.read`, … · `subscriber.read` YO'Q
 *   RESELLER — `subscriber.read` + CRUD, `grant.issue`, `plan.read`, …
 *              · `subscriber.directory` va `agent.fund` YO'Q
 *
 * ⚠️ «Pul ham oladigan reseller» — sherik yozuvidagi BAYROQ, rol
 * nusxasi emas: u `CASH_DESK` to'plamini (`subscriber.directory` +
 * `agent.fund`) ustiga oladi. Ya'ni pastdagi tekshiruvlar shu holatni
 * ham O'ZIDAN to'g'ri hal qiladi — alohida shox yozish kerak emas.
 */
export const PERM = {
  /** Abonentni to'liq ko'rish — doiraga bo'ysunadi (reseller) */
  subscriberRead: 'subscriber.read',
  /**
   * Tenant bo'ylab QISQARTIRILGAN abonent ro'yxati.
   *
   * ⚠️ Bu AYNI PAYTDA «kassa» belgisi: `PartnerKind.CASH_DESK` uni
   * `agent.fund` bilan birga beradi, ya'ni «bu odam pul oladimi»
   * degan savolga javob shu kod. Panel boshlang'ich ekranni ham
   * shundan tanlaydi (ADR-030 §1).
   */
  subscriberDirectory: 'subscriber.directory',
  /** Abonent balansini agent depozitidan to'ldirish */
  agentFund: 'agent.fund',
  /**
   * Sherikning O'Z pul ma'lumoti: tugun, depozit, chegara, komissiya
   * qoidasi va yig'indisi, amallar ro'yxati.
   *
   * ⚠️ `AgentMoneyController` ning BARCHA o'qish endpointlari shu
   * huquq ostida (`/balance`, `/operations`, `/commission-summary`,
   * `/commission-rules`, `/fund-limits`, `/outstanding`) va u
   * IKKALA sherik turida ham bor — kassa bayrog'idan MUSTAQIL.
   * Jonli o'lchov (Staging, 2026-08-21): kassasiz reseller
   * (`cash_desk = f`) shu oltitasining hammasidan `200` oladi,
   * `subscriber.directory` dan esa `403`.
   */
  agentRead: 'agent.read',
  /** Paket berish */
  grantIssue: 'grant.issue',
  /**
   * Chop etilgan kartani (vaucherni) ishlatish.
   *
   * ⚠️ IKKALA TURDA HAM BOR va bu o'lchangan, taxmin emas:
   * `PartnerKind.AGENT` (`:55`) va `PartnerKind.RESELLER` (`:92`)
   * to'plamlarining OXIRGI qatori aynan shu. Ya'ni «bu resellerga
   * kerak emas» degan shart PANELDA to'qilgan bo'lardi.
   *
   * ⚠️ Bu KASSA bayrog'idan MUSTAQIL: `subscriber.directory` va
   * `agent.fund` `CASH_DESK` to'plamida, bu esa BAZAVIY to'plamda.
   * Shuning uchun vaucher ekranini kassa oqimining ichiga qo'yish
   * kassasiz resellerni (`cash_desk = f`) server ochib bergan
   * amaldan mahrum qilardi — 2026-08-21 da tuzatilgan nuqsonning
   * aynan o'zi.
   *
   * ⚠️ `subscriber.create` EMAS. Endpoint ataylab shu huquq ostida
   * (`VoucherController.activate`, BUG-009): agentga KARTANI
   * ishlatish kerak, ixtiyoriy abonent ochish emas.
   */
  voucherActivate: 'voucher.activate',
  /**
   * O'Z kartalarini (partiyalarini va ulardagi kodlarni) KO'RISH.
   *
   * ⚠️ SERVERDA BOR — o'lchandi 2026-08-24:
   * `Permission.VOUCHER_STOCK_READ("voucher.stock.read")` va u
   * `PartnerKind` ning IKKALA to'plamida ham bor
   * (`PartnerKind.java:63` — AGENT, `:125` — RESELLER).
   *
   * ⚠️ DOIRA TURDAN KELIB CHIQADI va panel uni TAKRORLAMAYDI:
   * AGENT `OWN` (aynan o'z tuguniga berilgan partiya), RESELLER
   * `SUBTREE` (o'z shoxi). Ya'ni «kimning partiyasi» degan savolga
   * server javob beradi — bu yerda faqat havola ochiladi.
   *
   * ⚠️ `voucher.activate` QAYTA ISHLATILMADI: u AMAL huquqi
   * («kartani ishlat»), bu esa OMBOR huquqi («menda nima bor»).
   * Ularni bitta kodga yig'ish kartani ishlata oladigan HAR kimga
   * boshqa sherikning kodlarini ko'rish yo'lini ochardi — kod esa
   * bearer sir.
   */
  voucherStockRead: 'voucher.stock.read',
  /**
   * Abonent kontaktining TO'LIQ telefon raqamini ochish.
   *
   * ⚠️ `Permission.DANGEROUS` toifasida: amal AUDITGA tushadi va
   * SABAB majburiy. `PartnerKind` ning ikkala to'plamida ham bor
   * (`PartnerKind.java:83` va reseller to'plamidagi juftligi) —
   * egasi qarori (2026-08-24): kassir mijozga qo'ng'iroq qiladi,
   * huquq unga KERAK.
   *
   * ⛔ HUQUQ YOLG'IZ YETARLI EMAS va bu o'lchangan. Umumiy reestrning
   * `POST /api/contacts/{id}/reveal` yo'li huquqdan TASHQARI butun
   * tenantni qamraydigan DOIRANI ham talab qiladi
   * (`ContactServiceImpl.reveal:182` -> `TenantWideGuard.require`),
   * sherikning doirasi esa `OWN`/`SUBTREE`. Shuning uchun panel
   * ABONENT doirasiga bo'ysunadigan yangi yo'lni chaqiradi:
   * `POST /api/subscribers/{id}/contact/reveal`
   * (`features/subscriber/contactRevealApi.ts`).
   *
   * ⚠️ Bu huquq FAQAT KONTAKT raqamini ochadi. `subscriber.phone`
   * (abonent yozuvidagi E.164, SMS o'shandan oqadi — ADR-031 §2)
   * BOSHQA maydon va uning ochish yo'li umuman yo'q.
   */
  contactReveal: 'contact.reveal',
  /** Abonentning pul va paket tarixi; AGENT faqat o'ziga biriktirilgan abonentni ko'radi */
  subscriberHistoryView: 'subscriber.history.view',
} as const

export type PartnerPermission = (typeof PERM)[keyof typeof PERM]
